import React, { useContext, useState } from "react";
import { CartContext } from "../Component/CartContext";
import "../css/checkout.css";
import productData from "../Datas/productData";
import Footer from "./Footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import ReactFlagsSelect from "react-flags-select";
import Header from "./Header";

const CheckOut = () => {
  const { cartItems, clearCart } = useContext(CartContext);
  const [card, setCard] = useState("");
  const [date, setDate] = useState("");
  const [security, setSecurity] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [apartment, setApartment] = useState("");
  const [city, setCity] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [state, setState] = useState("");
  const [selectedShipping, setSelectedShipping] = useState("standard");
  const [errors] = useState({});
  const navigate = useNavigate();
  const [cardName, setCardName] = useState("");
  const [contact, setContact] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [company, setCompany] = useState("");

  const shippingMethods = [
    {
      id: "standard",
      name: "Standard Shipping",
      price: "Free",
      time: "7-14 business days",
    },
    {
      id: "express",
      name: "Express Shipping",
      price: "€9.99",
      time: "3-5 business days",
    },
    {
      id: "overnight",
      name: "Overnight Shipping",
      price: "€19.99",
      time: "1-2 business days",
    },
  ];
  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const location = useLocation();
  const { sub } = location.state || {};

  const handlePlaceOrder = () => {
    const newErrors = {};
    const cardInputs = document.querySelectorAll(
      'input[name="date"], input[name="security"], input[name="cardName"],input[name="contact"], input[name="firstName"], input[name="lastName"], input[name="address"],input[name="city"], input[name="postalCode"],input[name="cardName"]'
    );
    cardInputs.forEach((input) => {
      if (input.tagName === "SELECT" || input.tagName === "INPUT") {
        if (!input.value) {
          newErrors[input.name] = "该项目必须填写";
          input.style.border = "2px solid red";
        } else {
          input.style.border = "";
        }
      }
    });
    if (!contact) newErrors.contact = "Enter an email or phone number";
    if (!phone) newErrors.phone = "Enter a valid phone number";
    if (!postalCode) newErrors.postalCode = "Enter a ZIP / postal code";
    if (!date) newErrors.date = "Enter a valid expiration date";
    if (!card) newErrors.card = "Enter a card number";
    if (!security)
      newErrors.security = "Enter the CVV or security code on your card";
    if (!firstName) newErrors.firstName = "Enter a first name";
    if (!lastName) newErrors.lastName = "Enter a last name";
    if (!address) newErrors.address = "Enter an address";
    if (!city) newErrors.city = "Enter a city";
    if (!cardName)
      newErrors.cardName =
        "Enter your name exactly as it's written on your card";

    // setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      alert("Please fill all fields");
    } else {
      // Mock payment result randomly (90% success, 10% fail for testing)
      const isSuccess = Math.random() > 0.1;

      if (isSuccess) {
        const orderNumber = `ORD-${Date.now()}-${Math.floor(
          Math.random() * 1000
        )}`;
        const currentDate = new Date().toISOString().split("T")[0];

        let newOrder = null;
        if (sub) {
          newOrder = {
            id: orderNumber,
            status: "processing",
            date: currentDate,
            items: [
              { productId: sub.id, quantity: 1, size: sub.size || "Default" },
            ],
            total: parseFloat(sub.price),
            subtotal: parseFloat(sub.price),
            shipping: 0,
            shippingAddress: {
              name: `${firstName} ${lastName}`.trim(),
              phone: phone,
              address: `${address}${
                apartment ? `, ${apartment}` : ""
              }, ${city}, ${state} ${postalCode}`,
            },
            paymentMethod: "Credit Card",
          };
        } else {
          newOrder = {
            id: orderNumber,
            status: "processing",
            date: currentDate,
            items: cartItems.map((item) => ({
              productId: item.id,
              quantity: item.quantity,
              size: item.size || "Default",
            })),
            total: calculateTotal(),
            subtotal: calculateTotal(),
            shipping: 0,
            shippingAddress: {
              name: `${firstName} ${lastName}`.trim(),
              phone: phone,
              address: `${address}${
                apartment ? `, ${apartment}` : ""
              }, ${city}, ${state} ${postalCode}`,
            },
            paymentMethod: "Credit Card",
          };
        }

        const existingOrders = JSON.parse(
          localStorage.getItem("myOrders") || "[]"
        );
        localStorage.setItem(
          "myOrders",
          JSON.stringify([newOrder, ...existingOrders])
        );

        clearCart();
        navigate("/paysuccess", { state: { orderNumber } });
      } else {
        navigate("/payfail");
      }
    }
  };

  const calculateTotal = () => {
    return cartItems.reduce((total, item) => {
      const product = getProductById(item.id);
      if (!product) return total;

      const price = parseFloat(product.price, 10);
      return total + price * item.quantity;
    }, 0);
  };

  const formatCardNumber = (e) => {
    let { value } = e.target;
    value = value.replace(/\D/g, "");
    value = value.replace(/\d{4}(?=\d)/g, "$& ");
    value = value.substring(0, 19);
    setCard(value);
  };

  const formatDate = (e) => {
    let { value } = e.target;
    // 只允许输入数字和斜杠
    value = value.replace(/[^\d/]/g, "");
    if (value.length > 1 && value.indexOf("/") === -1) {
      value += "/";
    }
    value = value.substring(0, 5);
    setDate(value);
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const isVideo = (url) => /\.(mp4|webm|ogg)(\?.*)?$/i.test(url);

  return (
    <body
      id="ban-do-we-exist-to-help-you-be-your-best"
      className="template-index theme-animate-hover"
    >
      <Header />
      <div className="main-containerCheck">
        <div className="check-custom-checkout-page">
          <div className="left">
            <div className="check-order-info">
              <div className="express-checkout-container">
                <div className="express-checkout-divider">
                  <span>Express checkout</span>
                </div>
                <div className="express-checkout-actions">
                  <a
                    href="https://www.paypal.com"
                    target="_blank"
                    rel="noreferrer"
                    type="button"
                    className="paypal-button"
                  >
                    <span className="paypal-logo">
                      <i>Pay</i>
                      <i>Pal</i>
                    </span>
                  </a>
                </div>
              </div>

              <div className="form-divider">
                <span>OR</span>
              </div>

              <form>
                <div className="form-group">
                  <label>Contact</label>
                  <input
                    type="text"
                    id="contact"
                    name="contact"
                    value={contact}
                    placeholder="Email or mobile phone number"
                    onChange={(e) => setContact(e.target.value)}
                    required
                  />
                  {errors.contact && <p className="error">{errors.contact}</p>}
                </div>

                <div className="form-group">
                  <label>Delivery Address</label>
                  <ReactFlagsSelect
                    selected={countryCode}
                    onSelect={(code) => setCountryCode(code)}
                    className="check-select"
                    placeholder="Select country"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={firstName}
                      placeholder="First name *"
                      onChange={(e) => setFirstName(e.target.value)}
                      required
                    />
                    {errors.firstName && (
                      <p className="error">{errors.firstName}</p>
                    )}
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={lastName}
                      placeholder="Last name *"
                      onChange={(e) => setLastName(e.target.value)}
                      required
                    />
                    {errors.lastName && (
                      <p className="error">{errors.lastName}</p>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    id="company-name"
                    name="company-name"
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                    placeholder="Company name (optional)"
                  />
                </div>

                <div className="form-group">
                  <PhoneInput
                    country={"us"}
                    value={phone}
                    onChange={(phone) => setPhone(phone)}
                    inputProps={{
                      name: "phone",
                      required: true,
                    }}
                    containerClass="phone-input-container"
                    inputClass="phone-input-field"
                    buttonClass="phone-input-button"
                    dropdownClass="phone-input-dropdown"
                  />
                  {errors.phone && <p className="error">{errors.phone}</p>}
                </div>

                <div className="form-group">
                  <label className="section-label">Street Address</label>
                  <input
                    type="text"
                    id="address"
                    name="address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    required
                    placeholder="Street address *"
                  />
                  {errors.address && <p className="error">{errors.address}</p>}
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    id="apartment"
                    name="apartment"
                    value={apartment}
                    onChange={(e) => setApartment(e.target.value)}
                    placeholder="Apartment, suite, unit, etc. (optional)"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      id="city"
                      name="city"
                      value={city}
                      placeholder="City *"
                      onChange={(e) => setCity(e.target.value)}
                      required
                    />
                    {errors.city && <p className="error">{errors.city}</p>}
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      id="state"
                      name="state"
                      value={state}
                      placeholder="State / Province"
                      onChange={(e) => setState(e.target.value)}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      id="postalCode"
                      name="postalCode"
                      value={postalCode}
                      placeholder="Postal Code *"
                      onChange={(e) => setPostalCode(e.target.value)}
                      required
                    />
                    {errors.postalCode && (
                      <p className="error">{errors.postalCode}</p>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label>Payment</label>
                  <div className="payment-box">
                    <div className="payment-header">
                      <div className="payment-header-left">Credit card</div>
                      <div className="payment-header-right">
                        <img
                          alt="Visa"
                          src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/visa.sxIq5Dot.svg"
                        />
                        <img
                          alt="Mastercard"
                          src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/mastercard.1c4_lyMp.svg"
                        />
                        <img
                          alt="Amex"
                          src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/amex.Csr7hRoy.svg"
                        />
                        <img
                          alt="Discover"
                          src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/discover.C7UbFpNb.svg"
                        />
                      </div>
                    </div>
                    <div className="payment-body">
                      <input
                        type="text"
                        value={card}
                        name="cardNumber"
                        onChange={formatCardNumber}
                        placeholder="Card Number"
                      />
                      {errors.card && <p className="error">{errors.card}</p>}
                      <div className="form-row">
                        <input
                          type="text"
                          value={date}
                          name="date"
                          onChange={formatDate}
                          placeholder="Expiration date (MM / YY)"
                        />
                        <input
                          type="text"
                          value={security}
                          name="security"
                          onChange={(e) => setSecurity(e.target.value)}
                          placeholder="Security code"
                        />
                      </div>
                      <input
                        type="text"
                        value={cardName}
                        name="cardName"
                        onChange={(e) => setCardName(e.target.value)}
                        placeholder="Name on card"
                      />
                      {errors.cardName && (
                        <p className="error">{errors.cardName}</p>
                      )}
                    </div>
                  </div>
                </div>
              </form>
              <button
                className="check-checkout-button"
                onClick={handlePlaceOrder}
              >
                Pay Now
              </button>

              <p>
                <Link
                  to="/returns"
                  style={{ textDecoration: "underline" }}
                  onClick={toTop}
                >
                  Shipping & Returns Info
                </Link>
              </p>
            </div>
          </div>

          {!sub && (
            <div className="right">
              <div className="check-order-summary">
                <div className="check-order-details">
                  {cartItems.map((item, index) => {
                    const product = getProductById(item.id);
                    if (!product || !product.images) return null;
                    const primaryImage = product.images[0];
                    return (
                      <div key={index} className="check-cart-item">
                        {isVideo(primaryImage) ? (
                          <video
                            src={primaryImage}
                            autoPlay
                            muted
                            loop
                            playsInline
                          />
                        ) : (
                          <img src={primaryImage} alt="Product" />
                        )}
                        <div className="pro--qty">
                          <div className="qty-inner">{item.quantity}</div>
                        </div>
                        <div className="check-item-details">
                          <h3>{product.name}</h3>
                        </div>
                        <p className="cal-single">€{product.price} </p>
                      </div>
                    );
                  })}

                  <div className="check-summary-details">
                    <div className="gridTotal">
                      <table className="summary-details22">
                        <tbody className="sumTbody22">
                          <tr className="sumTr22">
                            <th
                              className="subtotalTh22"
                              style={{ fontSize: "24px" }}
                            >
                              Total
                            </th>
                            <th className="subtotalTxt22">
                              €{calculateTotal().toFixed(2)}
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </body>
  );
};

export default CheckOut;
